export default "__VITE_ASSET__SFNxPE6Y__"